import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filterSelectors } from '../Modules/filters';
import isEmpty from 'lodash/isEmpty';
import { transform as tripTypeListTransform } from 'utils/DataTransform/Trips/tripType';
import {
  transform as detailsTransform,
  transformTripDataForForm,
} from 'utils/DataTransform/Trips/tripTypeDetail';

export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);
export const getFilters = createSelector(
  filterSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getTripTypeListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    return tripTypeListTransform(list);
  },
);
export const getTripTypeDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (isEmpty(details)) return {};
    const transformedDetails = detailsTransform(details);
    return transformedDetails;
  },
);
export const getTripTypeDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (isEmpty(details)) return {};
    return rawTransform(details);
  },
);

const rawTransform = details => {
  const [listTransformWithRateConversion] = tripTypeListTransform([details]);
  return transformTripDataForForm(listTransformWithRateConversion);
};
